import * as React from "react";
import { makeStyles } from '@mui/styles';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Filter,
    TextInput,
    Show,
    SimpleShowLayout, ShowButton, ReferenceField,
    useRecordContext,
    Pagination
} from 'react-admin';
import { Card, CardContent } from '@mui/material';
import ShowActions from './showActions';

const AdresseFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Straße" source="name" alwaysOn />
        <TextInput label="Hausnummer" source="hausnummer_von" alwaysOn />
        <TextInput label="PLZ" source="plz" alwaysOn />
        <TextInput label="Ort" source="ort" alwaysOn />
        <TextInput label="Ortsteil" source="ortsteil" alwaysOn />
    </Filter>
);

const AdresseList = props => {
    return (
        <List title={"Adresse"}
              filters={<AdresseFilter />}
              pagination={<Pagination rowsPerPageOptions={[10, 15, 20]} {...props} />}
              exporter={false}
              {...props}
        >
            <Datagrid
                sx={{
                    '& .RaDatagrid-headerCell': {
                        fontWeight: 'bold',
                    }}
                } rowClick="edit">
                <TextField label="Straße" source="name" />
                <TextField source="hausnummerVon" />
                <TextField source="hausnummerBis" />
                <TextField label="PLZ" source="plz" />
                <TextField source="ort" />
                <ReferenceField label={"Ortsteil"} source={"gemeindeteil"} reference={"gemeindeteile"}>
                    <TextField source="name" />
                </ReferenceField>
                <ShowButton label={"Details"} />
            </Datagrid>
        </List>
    )
}

const useStyles = makeStyles({
    card: {
        'margin-bottom': '15px'
    }
});

const CardAdresse = () => {
    const classes = useStyles();
    const record = useRecordContext();
    var strHausnummer = record.name + (record.hausnummerVon ? ' ' + record.hausnummerVon : '') + (record.hausnummerBis ? ' ' + record.hausnummerBis : '');
    var plzOrt = record.plz + ' ' + record.ort;
    return (
        <Card className={classes.card}>
            <CardContent>
                <b>ADRESSE</b><br />
                <br />
                {strHausnummer}<br />
                {plzOrt}
            </CardContent>
        </Card>
    );
}

const AdresseShow = (props) => (
    <Show title={"Adresse"} actions={<ShowActions />} {...props}>
        <SimpleShowLayout>
            <CardAdresse></CardAdresse>
            <TextField source="id" />
            <TextField source="objektNr" />
            <TextField source="name" />
            <TextField source="hausnummerVon" />
            <TextField source="hausnummerBis" />
            <TextField source="hausnummerZusatz" label={"Haunummer Zusatz"} />
            <TextField source="anmerkung" />
            <TextField source="plz" label={"PLZ"} />
            <TextField label={"Ort (relevant für die Adresseingabe im Sperrmüllportal)"} source="ort" />
            <ReferenceField label={"Ortsteil (relevant für die Zuordnung zum Abholgebiet)"} source={"gemeindeteil"} reference={"gemeindeteile"} link={false}>
                <TextField source="name" />
            </ReferenceField>
            <TextField source="abholgebiet" />
            <TextField source="volumenSumme" label={"Volumen Summe"} />
            <TextField source="anzahl" />
            <TextField source="volumenDurchschnitt" label={"Volumen Durchschnitt"} />
            <ReferenceField label={"Datenquelle"} source={"quelle"} reference={"quellen"} link={false}>
                <TextField source="bezeichnung" />
            </ReferenceField>
            <ReferenceField label={"Datenquelle vom"} source={"quelle"} reference={"quellen"} link={false}>
                <DateField source="insertDate" />
            </ReferenceField>
        </SimpleShowLayout>
    </Show>
);

export {AdresseList, AdresseShow, CardAdresse};
